<template>
  <div class="relative mb-6">
    <template v-if="!expired">
      <div class="relative">
        <div
          class="mb-0 leading-tight"
          :class="$style['layout-color']"
        >
          <div
            class="py-0 px-3 quill-class"
            v-html="timelineBody.timeline"
          />
        </div>

        <div v-if="pinnedReactions.length > 0">
          <div
            v-for="reaction in pinnedReactions"
            :key="reaction.id"
          >
            <div class="mb-4">
              <XBroadcastReaction
                :reaction="reaction"
                :shareChannels="shareChannels"
                :shareDescription="shareDescription"
                :shareMessage="shareMessage"
                :shareHashtags="shareHashtags"
                showDateType
                allowHijack
              />
            </div>
          </div>
        </div>

        <div v-if="noPinnedReactions.length > 0">
          <div
            v-for="reaction in noPinnedReactions"
            :key="reaction.id"
          >
            <div class="mb-4">
              <XBroadcastReaction
                :reaction="reaction"
                :shareChannels="shareChannels"
                :shareDescription="shareDescription"
                :shareMessage="shareMessage"
                :shareHashtags="shareHashtags"
                showDateType
                allowHijack
              />
            </div>
          </div>
        </div>

        <XCard
          v-if="reactionList.length <= 0"
          class="py-6 px-4"
        >
          <div
            class="py-2 px-3 quill-class"
            v-html="timelineBody.noReactions"
          />
        </XCard>
      </div>
    </template>

    <XCard
      v-else
      class="py-6 px-4 mt-16"
    >
      <div
        class="py-2 px-3 quill-class"
        v-html="timelineBody.closed"
      />
    </XCard>
  </div>
</template>

<script>
import { DateTime } from 'luxon'
import _ from 'lodash'

import formatDateToRelative from '@common/utils/formatDateToRelative'

import XBroadcastReaction from '@plat/views/event/reactions/broadcast/Index'

export default {
  components: {
    XBroadcastReaction
  },

  props: {
    timelineBody: {
      type: Object
    },
    timelineConfig: {
      type: Object
    },
    reactions: {
      type: Array
    },
    expired: {
      type: Boolean
    }
  },

  data () {
    return {
      reactionsData: this.reactions
    }
  },

  computed: {
    shareChannels () {
      const formattedChannels = _.map(this.timelineConfig.share.channels, (withChannel, type) => ({
        channel: type,
        enabled: withChannel
      }))
      const filteredChannels = _.filter(formattedChannels, 'enabled')
      const mappedChannels = _.map(filteredChannels, 'channel')

      return mappedChannels.length > 0
        ? mappedChannels
        : null
    },

    shareDescription () {
      return this.timelineConfig.share.description || ''
    },

    shareMessage () {
      return this.timelineConfig.share.message || ''
    },

    shareHashtags () {
      return this.timelineConfig.share.hashtags
    },

    reactionList () {
      if (this.reactionsData.length === 0) {
        return []
      }

      return this.reactionsData
        .map(reaction => {
          const date = DateTime.fromISO(reaction.data.publicationDate)
          const relativeDate = formatDateToRelative(date)

          return {
            ...reaction,
            relativeDate: this.$tc(
              'common.dates.' + relativeDate.unit,
              relativeDate.diff,
              { unit: relativeDate.diff }
            )
          }
        })
    },

    noPinnedReactions () {
      return this.reactionList
        .filter(reaction => (this.reactionHasPinnedProperty(reaction) && !reaction.data.pinned) ||
                            !this.reactionHasPinnedProperty(reaction)
        )
    },

    pinnedReactions () {
      return this.reactionList
        .filter(reaction => this.reactionHasPinnedProperty(reaction) && reaction.data.pinned)
    }
  },

  methods: {
    addReaction (reaction) {
      this.reactionsData.unshift(reaction)
    },

    reactionHasPinnedProperty (reaction) {
      return reaction && reaction.data && reaction.data.hasOwnProperty('pinned')
    }
  }
}
</script>

<style module>
.line {
  stroke: #c7c7c7;
  stroke-width: 2px;
  stroke-dasharray: 100, 1;
  stroke-linecap: round;
}

.layout-color {
  background-color: #fafafa;
}

.down-icon {
  left: -60px;
  background-color: #fafafa;
  color: #c7c7c7;
}

.footer-image {
  max-width: 120px;
  min-width: 35px;
  max-height: 120px;
  min-height: 35px;
}
</style>
